import * as React from "react";
import { cn } from "@/lib/utils";

type Variant = "primary" | "secondary" | "ghost" | "danger";
type Size = "sm" | "md" | "lg";

const VARIANTS: Record<Variant, string> = {
  primary: "vb-btn--primary",
  secondary: "", // base .vb-btn is the neutral/secondary style
  ghost: "vb-btn--ghost",
  danger: "vb-btn--danger",
};

const SIZES: Record<Size, string> = {
  sm: "vb-btn--sm",
  md: "", // base .vb-btn is 36px
  lg: "vb-btn--lg",
};

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
  /** Full-width — the prototype's plan/step CTAs. */
  block?: boolean;
};

/** Design-system button, ported 1:1 from the aits-2.0 `.btn` (gradient bg +
 *  1px border + brand shadow). Styling lives in vb-primitives.css (unscoped
 *  since AITS-494, so it works on the historical screens too). */
export const VbButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ variant = "primary", size = "md", block, className, ...props }, ref) => (
    <button
      ref={ref}
      className={cn("vb-btn", VARIANTS[variant], SIZES[size], block && "vb-btn--block", className)}
      {...props}
    />
  ),
);
VbButton.displayName = "VbButton";

export default VbButton;
